import React from "react";
import { Outlet } from 'react-router-dom'


function Container() {
  return (
    <>
      <Outlet />
    </>
  );
}

export default Container;
